import React, { Component } from "react";
import "./App.css";
import "./assets/main.css";
import { Popup } from "./containers/Popup";
import UserProvider from "./containers/UserProvider";
import "./styles/index.css";

class App extends Component {
  render() {
    return (
      <div
        className="App bg-gray-800 bg-opacity-60 top-0 left-0 mt-2 absolute text-white rounded-xl"
        style={{
          width: "100%",
          backdropFilter: "blur(20px)",
        }}
      >
        <UserProvider>
          <Popup chrome={this.props.chrome} />
        </UserProvider>
      </div>
    );
  }
}

export default App;
